import React, { useEffect, useContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../contexts/AuthContext';

const Callback = () => {
  const { login } = useContext(AuthContext);
  const [error, setError] = useState('');
  const [status, setStatus] = useState('Processing your login...');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleCallback = async () => {
      const urlParams = new URLSearchParams(location.search);
      const code = urlParams.get('code');
      
      if (code) {
        try {
          setStatus('Authenticating with Discord...');
          
          // Try a more flexible approach to reaching the API
          let apiUrl;
          if (window.location.hostname === 'localhost') {
            // Local development
            apiUrl = 'http://localhost:5000/auth/discord/callback';
          } else {
            // Try a serverless function URL first
            apiUrl = '/api/discord?path=callback';
          }
          
          console.log(`Sending auth request to: ${apiUrl}`);
          const response = await axios.post(apiUrl, { code });
          login(response.data);
          navigate('/apply');
        } catch (err) {
          console.error('Authentication error:', err);
          setError(`Failed to authenticate with Discord. Error: ${err.message}`);
          setStatus('Authentication failed');
        }
      } else {
        setError('No authentication code received from Discord.');
        setStatus('Authentication failed');
      }
    };

    handleCallback();
  }, [location, login, navigate]);

  if (error) {
    return (
      <div className="container">
        <h2>Authentication Error</h2>
        <div className="error-message">{error}</div>
        <p>Server connection details:</p>
        <pre>
          API URL: {process.env.REACT_APP_API_URL || 'Not set'}<br />
          Environment: {process.env.NODE_ENV || 'Not set'}
        </pre>
        <button onClick={() => navigate('/')} className="discord-login-button">
          Back to Login
        </button>
      </div>
    );
  }

  return (
    <div className="container">
      <h2>{status}</h2>
      <p>Please wait while we authenticate your Discord account.</p>
    </div>
  );
};

export default Callback;
